import { SaasAxios } from '@quick/saas-axios'
export function useSwitchAccount() {
  const switchAccount = (openUrl, companyId) => {
    // todo 切换账号失败了怎么办
    // const defaultURL = `https://www.kdocs.cn/ent/${companyId.value}/helper`
    // const cb = window.$initRouteVueMode
    window.epPlatform.multiAccountApi.goLoginAccountPage({
      cb:
        openUrl.value ||
        `${SaasAxios.getHost('KDOCS')}/ent/${companyId.value}/helper`,
      autologin: false,
    })
  }
  return {
    switchAccount,
  }
}
